import {createStore} from 'vuex';

import BaseData from './baseData';
import uiModule from './ui';
import Token from './token';
import Syarat from './syarat';
import SyaratJenis from './syaratJenis';

export default createStore({
    modules: {
        baseData:   BaseData,
        ui:         uiModule,
        token : Token,
        syarat  : Syarat,
        syaratJenis : SyaratJenis
    }
});
